module.exports = __webpack_public_path__ + "static/img/SplashPage.236a7d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-swfl-wgm/images/SplashPage.jpg
// module id = eoYj
// module chunks = 44